import { useEffect, useRef } from 'react';
import {
  getWebFcmToken,
  syncPushSubscriptionWithBackend,
  registerForegroundMessageListener,
} from '../firebase/webPush';

function hasAuthSession() {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  return !!(
    sessionStorage.getItem('adminkhadamat') ||
    sessionStorage.getItem('storekhadamat') ||
    sessionStorage.getItem('doctorKhadamat') ||
    sessionStorage.getItem('clinicKhadamat')
  );
}

/**
 * FCM للويب + topic all_clients: يُفعَّل مرة بعد ظهور جلسة، ويُعاد ضبطه عند انتهاء الجلسة.
 * pathname يضمن إعادة المحاولة بعد تسجيل الدخول (حتى مع SPA بدون إعادة تحميل كاملة).
 */
export default function usePushNotifications(pathname) {
  const sessionReadyRef = useRef(false);
  const offForegroundRef = useRef(() => {});

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (!hasAuthSession()) {
      sessionReadyRef.current = false;
      offForegroundRef.current();
      offForegroundRef.current = () => {};
      return;
    }

    if (sessionReadyRef.current) {
      return;
    }
    sessionReadyRef.current = true;

    (async () => {
      try {
        await getWebFcmToken();
        await syncPushSubscriptionWithBackend();
        offForegroundRef.current = await registerForegroundMessageListener();
      } catch {
        // تجاهل — الصلاحيات أو المتصفح قد يمنع الإشعارات
      }
    })();
  }, [pathname]);
}
